import type { DefinedUseQueryResult, QueryFunction, QueryKey } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

type UseFetchHookProps = {
  keys: QueryKey;
  api: QueryFunction<any, QueryKey>;
  initialData?: any;
  options?: any;
};

const useFetchHook = <T>({
  keys,
  api,
  initialData,
  options,
}: UseFetchHookProps): DefinedUseQueryResult<T> => {
  const fetchQuery = useQuery({
    queryKey: keys,
    queryFn: api,
    ...(initialData && { initialData }),
    ...options, // Spread any additional options here
  });

  return fetchQuery as DefinedUseQueryResult<T>;
};

export default useFetchHook;
